// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Main-module--cds--assistive-text--681af";
export var cdsHideFeedback = "Main-module--cds--hide-feedback--9a2e1";
export var cdsShowFeedback = "Main-module--cds--show-feedback--36e38";
export var cdsSkeleton = "Main-module--cds--skeleton--0c6ee";
export var cdsVisuallyHidden = "Main-module--cds--visually-hidden--93304";
export var main = "Main-module--main--3c1fa";
export var padded = "Main-module--padded--2eee7";